import React from 'react';
import stakeS from '../../assets/stake-s.png';

export const StakeMonogram = () => <img className="settings-stake-monogram" src={stakeS} alt="" aria-hidden="true" data-testid="account-details-stake-logo" />;